import { FC } from "react"
import { SafetiesList } from "../../../../module/safeties/containers/list/index"

export const SafetiesListHistoryPage: FC = () => <SafetiesList />
